import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import RoutesserviceService from '../routesservice.service';
import { HeaderService } from '../header.service';




const httpOptions = new HttpHeaders()
  .set('content-type', 'application/json');

@Injectable({
  providedIn: 'root'
})
export class SettingservicesService {

  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService

  ) { }
  async getTypeHere() {
    return this.httpClient
      .get(this.Customeroutes.getType(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });

  }
  async createAutomationText(data: any) {
    const sdata = {
      type_id: data.id,
      text: data.text,
      organization_id: data.org_id,
    }
    return this.httpClient
      .post(this.Customeroutes.createTextAutomation(), sdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }
  async getTextAuto() {
    return this.httpClient
      .post(this.Customeroutes.getTextAutomation(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }
  async editAutomationText(data: any, id: any) {
    const sdata = {
      id: id,
      type_id: data.id,
      text: data.text,
      organization_id: data.org_id,
    }


    return this.httpClient
      .post(this.Customeroutes.editTextAutomation(), sdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {

          return data;
        }
      });
  }

  async delTextAutomation(id: any) {
    const modal = {
      id: id
    }
    return this.httpClient
      .post(this.Customeroutes.deleteTextAutomation(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }

  async orgdetail(data: any) {
    const orgdata = {
      name: data.org_name,
      slogan: data.org_slogan,
      type: data.org_type,
      address1: data.org_address1,
      address2: data.org_address2,
      city: data.org_city,
      state: data.org_state,
      country: data.org_country,
      postal_code: data.org_postal_code
    }


    return this.httpClient
      .post(this.Customeroutes.setOrgData(), orgdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }


  async orgedit(data: any, org_id: any) {
    const orgdata = {
      id: org_id,
      name: data.org_name,
      slogan: data.org_slogan,
      type: data.org_type,
      address1: data.org_address1,
      address2: data.org_address2,
      city: data.org_city,
      state: data.org_state,
      country: data.org_country,
      postal_code: data.org_postal_code
    }


    return this.httpClient
      .post(this.Customeroutes.editorg(), orgdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {

          return data;
        }
      });
  }

  async getorgdetail() {
    return this.httpClient
      .post(this.Customeroutes.getOrgData(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }


  async getorgdelete(id: any) {
    const modal = {
      id: id
    }
    return this.httpClient
      .post(this.Customeroutes.getdeleteorg(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }
  async desdetail(data: any) {
    const desdata = {
      designation_name: data.des_name,
      description: data.des_description,
      organization_id: data.orgnazation.id
    }


    return this.httpClient
      .post(this.Customeroutes.setDesData(), desdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }

  async desedit(data: any, id: any) {
    const desdata = {
      id: id,
      designation_name: data.des_name,
      description: data.des_description,
      organization_id: data.orgnazation.id
    }


    return this.httpClient
      .post(this.Customeroutes.editDesData(), desdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }

  async getDesdetail() {
    return this.httpClient
      .post(this.Customeroutes.getDesData(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }



  async getdesdelete(id: any) {
    const modal = {
      id: id
    }
    return this.httpClient
      .post(this.Customeroutes.getdeletedes(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }
  // departments


  async getdepdetail() {
    return this.httpClient
      .post(this.Customeroutes.getdepData(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }



  async depCreat(data: any) {
    const desdata = {
      department_name: data.dep_name,
      sub_department_name: data.subdep_name,
    }

    return this.httpClient
      .post(this.Customeroutes.setdepData(), desdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }




  async depedit(data: any, id: any) {
    const desdata = {
      id: id,
      department_name: data.dep_name,
      sub_department_name: data.subdep_name,
    }


    return this.httpClient
      .post(this.Customeroutes.editDepData(), desdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }


  async getdepdelete(id: any) {
    const modal = {
      id: id
    }
    return this.httpClient
      .post(this.Customeroutes.getdeletedep(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }







  // policy
  async policyCreate(data: any) {

    const desdata = {
      policy_title: data.policy_title,
      policy_description: data.policy_description,
    }


    return this.httpClient
      .post(this.Customeroutes.setpolicyData(), desdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }

  async getpolicydetail() {
    return this.httpClient
      .post(this.Customeroutes.getpolicyData(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }

  async policyedit(data: any, id: any) {
    const desdata = {
      id: id,
      policy_title: data.policy_title,
      policy_description: data.policy_description,
    }


    return this.httpClient
      .post(this.Customeroutes.editpolciData(), desdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }


  async getpolicydelete(id: any) {
    const modal = {
      id: id
    }
    return this.httpClient
      .post(this.Customeroutes.getdeletpolicy(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }

  // category


  async categoryCreate(data: any) {

    const desdata = {
      name: data.category_name,
    }


    return this.httpClient
      .post(this.Customeroutes.setcategoryData(), desdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }



  async getcategorydetail() {
    return this.httpClient
      .post(this.Customeroutes.getcategoryData(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          return data;
        }
      });
  }

  async categoryedit(data: any, id: any) {
    const desdata = {
      id: id,
      name: data.category_name,
    }


    return this.httpClient
      .post(this.Customeroutes.editcategoryData(), desdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }

  async getCategorydelete(id: any) {
    const modal = {
      id: id
    }
    return this.httpClient
      .post(this.Customeroutes.getdeletcategory(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }

  // sub category

  async getSubCategorydetail() {
    return this.httpClient
      .post(this.Customeroutes.getSubCategoryData(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          return data;
        }
      });
  }



  async subcategoryCreate(data: any, expense_cat_id: any) {
    const desdata = {
      name: data.subcategory_name,
      amount: data.subcategory_amount,
      last_date: data.subcategory_date,
      status: data.subcategory_status,
      expense_cat_id: expense_cat_id,
      is_media: data.is_Media

    }


    return this.httpClient
      .post(this.Customeroutes.setsubcategoryData(), desdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }


  async subcategoryedit(data: any, expense_cat_id: any, subcategory_id: any) {
    const desdata = {
      id: subcategory_id,
      name: data.subcategory_name,
      amount: data.subcategory_amount,
      last_date: data.subcategory_date,
      status: data.subcategory_status,
      expense_cat_id: expense_cat_id,
      is_media: data.is_Media

    }


    return this.httpClient
      .post(this.Customeroutes.editsubcategoryData(), desdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }


  async getSubcategorydelete(id: any) {
    const modal = {
      id: id
    }
    return this.httpClient
      .post(this.Customeroutes.getdeletsubcategory(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }


  // leave addleaves


  async leaveCreate(data: any, toggleValueCompulsryLeave: any, _genderApplicability: any, _toggleValueTLAction: any) {
    const modal = {
      name: data?.leave_name,
      leave_quantity: data?.leave_count,
      type: data?.leave_type,
      compulsary_leave: toggleValueCompulsryLeave,
      gender_applicability: data?.gender_applicability,
      team_lead_action_type: _toggleValueTLAction
    }
    return this.httpClient
      .post(this.Customeroutes.addleave(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }


  async getleavesdetail() {
    return this.httpClient
      .post(this.Customeroutes.getleavesData(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          return data;
        }
      });
  }


  async leavesedit(data: any, id: any, toggleValueCompulsryLeave: any, _genderApplicability: any, _toggleValueTLAction: any) {
    const modal = {
      id: id,
      name: data?.leave_name,
      leave_quantity: data?.leave_count,
      type: data?.leave_type,
      compulsary_leave: toggleValueCompulsryLeave,
      gender_applicability: _genderApplicability,
      team_lead_action_type: _toggleValueTLAction
    }
    return this.httpClient
      .post(this.Customeroutes.addleave(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }

  async leavedelete(id: any) {
    const modal = {
      id: id
    }
    return this.httpClient
      .post(this.Customeroutes.getdeleteleave(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }

  async checkCreate(device_check: any, leave_check: any,auth_key :any, leave_date: any) {
    const modal = {
      device_check: device_check,
      leave_check: leave_check,
      leave_date: leave_date,
      auth_key: auth_key
    }
    return this.httpClient
      .post(this.Customeroutes.addkeys(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }


  async keysedit(device_check: any, leave_check: any, auth_key:any , leave_date: any, keysid: any,) {
    const modal = {
      id: keysid,
      device_check: device_check,
      leave_check: leave_check,
      auth_key:auth_key,
      leave_date: leave_date,
    }
    return this.httpClient
      .post(this.Customeroutes.addkeys(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }


  async getkeysdetail() {
    return this.httpClient
      .post(this.Customeroutes.getkeysData(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          return data;
        }
      });
  }

  async getkeydelete(id: any) {
    const modal = {
      id: id
    }
    return this.httpClient
      .post(this.Customeroutes.getdeletekey(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }




  async getkpsData() {
    return this.httpClient
      .post(this.Customeroutes.getkpsData(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          return data;
        }
      });
  }


  async kpsCreate(data: any,) {
    const modal = {
      name: data.kps_name,
      value: data.kps_value,
      type: data.employee_role
    }
    return this.httpClient
      .post(this.Customeroutes.addkps(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }



  async kpsListedit(data: any, id: any) {
    const modal = {
      id: id,
      name: data.kps_name,
      value: data.kps_value,
      type: data.employee_role
    }
    return this.httpClient
      .post(this.Customeroutes.editkps(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }

  async getkpsdelete(id: any,) {
    const modal = {
      id: id,
    }
    return this.httpClient
      .post(this.Customeroutes.deletekps(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }


  async getUSerRole() {
    return this.httpClient
      .post(this.Customeroutes.getUserRole(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          return data;
        }
      });
  }




  async deleteUSerRole(id: any,) {
    const modal = {
      id: id,
    }
    return this.httpClient
      .post(this.Customeroutes.deleteRole(), modal, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        return data;
      })
      .catch((error) => {
        return error.error; // return the server's error response
      });
    // .then((data: any) => {

    //   if (data) {
    //     if (data.success == true) {

    //       return data;
    //     }
    //   }
    //   return data;
    // });
  }



  
 async getauthReset() {
  
    return this.httpClient
      .post(this.Customeroutes.resetAuth(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        return data;
      })
      .catch((error) => {
        return error.error; // return the server's error response
      });
  }


  async addSeeder(data:any) {
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.addSeeder(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }


}
